(()=>{
  const initialize=(scope=document)=>{
    scope.querySelectorAll('[data-kw-gallery]').forEach(gallery=>{
      if(gallery.dataset.initialized)return;
      gallery.dataset.initialized='true';
      const media=Array.from(gallery.querySelectorAll('[data-media-index]'));
      const thumbs=Array.from(gallery.querySelectorAll('[data-gallery-index]'));
      const stage=gallery.querySelector('.kw-gal-m');
      const count=gallery.querySelector('[data-gallery-count]');
      const dialog=gallery.querySelector('dialog');
      let current=Math.max(0,media.findIndex(el=>!el.hidden));
      const select=index=>{
        if(!media.length)return;
        current=(index+media.length)%media.length;
        media.forEach((el,i)=>{
          if(i!==current){el.querySelectorAll('video').forEach(video=>video.pause());el.querySelectorAll('iframe').forEach(frame=>{if(!el.hidden)frame.src=frame.src;});}
          el.hidden=i!==current;
        });
        thumbs.forEach((el,i)=>el.setAttribute('aria-current',String(i===current)));
        if(count)count.textContent=String(current+1);
      };
      thumbs.forEach(button=>button.addEventListener('click',()=>select(Number(button.dataset.galleryIndex))));
      gallery.querySelectorAll('[data-gallery-step]').forEach(button=>button.addEventListener('click',()=>select(current+Number(button.dataset.galleryStep))));
      stage?.addEventListener('keydown',event=>{
        if(event.target.closest('video,iframe,model-viewer'))return;
        if(event.key==='ArrowLeft'){event.preventDefault();select(current-1);}
        if(event.key==='ArrowRight'){event.preventDefault();select(current+1);}
      });
      let start=null;
      stage?.addEventListener('touchstart',event=>{
        if(event.target.closest('video,iframe,model-viewer'))return;
        const touch=event.changedTouches[0];start={x:touch.clientX,y:touch.clientY};
      },{passive:true});
      stage?.addEventListener('touchend',event=>{
        if(!start)return;
        const touch=event.changedTouches[0],dx=touch.clientX-start.x,dy=touch.clientY-start.y;
        if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)select(current+(dx<0?1:-1));
        start=null;
      },{passive:true});
      let opener=null;
      gallery.querySelectorAll('[data-image-zoom]').forEach(link=>link.addEventListener('click',event=>{
        if(!dialog?.showModal)return;
        event.preventDefault();opener=link;
        const image=dialog.querySelector('img');image.src=link.href;image.alt=link.querySelector('img')?.alt||'';
        dialog.showModal();
      }));
      gallery.querySelector('[data-close-zoom]')?.addEventListener('click',()=>dialog.close());
      dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      dialog?.addEventListener('close',()=>opener?.focus());
    });
    scope.querySelectorAll('[data-variant-select]').forEach(select=>{
      if(select.dataset.initialized)return;
      select.dataset.initialized='true';
      select.addEventListener('change',()=>{
        const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.location.assign(url.href);
      });
    });
  };
  if(!window.kingdomCommerce){window.kingdomCommerce={initialize};document.addEventListener('shopify:section:load',event=>initialize(event.target));}
  initialize();
})();
